import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'  
import './css/custom.css';

const root = createRoot(document.getElementById("root"))
root.render(<App />);
